import React from 'react';
import { createUniqueKey } from '../../../utils';

type LegendItemProps = {
    name?: string;
    value?: string;
}

type LegendProps = {
    dataExternal?: LegendItemProps[];
    legendLabels?: LegendItemProps[];
}

function Legend(props: LegendProps) {
    const { dataExternal = [], legendLabels = [] } = props;

    return (
        <div className="projection-legend">
            {
                dataExternal?.map(
                    (item, index) => (
                        <div className={`projection-legend-item legend-external-item-${index}`} key={createUniqueKey(index, item.name)}>
                            <div className="legend-point" />
                            <div className="legend-name">
                                {item.name}
                                {": "}
                                <span className='legend-value'>{item?.value}</span>
                            </div>
                        </div>
                    ),
                )
            }
            {
                legendLabels?.map(
                    (item, index) => (
                        <div className={`projection-legend-item legend-item-${index}`} key={createUniqueKey(index, item)}>
                            <div className="legend-point" />
                            <div className="legend-name">
                                {item.name}
                                {": "}
                                <span className='legend-value'>{item?.value}</span>
                            </div>
                        </div>
                    ),
                )
            }
        </div>
    );
}

export default Legend;
